import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { setSubmissionStage } from 'actions';
import { submissionStages } from 'common/forms/submissionStages';

export const FORM_REVERT_REQUEST = 'FORM_REVERT_REQUEST';
export const FORM_REVERT_SUCCESS = 'FORM_REVERT_SUCCESS';
export const FORM_REVERT_FAILURE = 'FORM_REVERT_FAILURE';

function request() {
  return {
    type: FORM_REVERT_REQUEST
  };
}

function receive(workflowState) {
  return {
    type: FORM_REVERT_SUCCESS,
    workflowState
  };
}

function reject() {
  return {
    type: FORM_REVERT_FAILURE
  };
}

export function revertForm(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .revert(id)
      .then((response) => {
        dispatch(receive(response.data.data));
        dispatch(setSubmissionStage(submissionStages.Validating));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}

export function revertFormGroup(id) {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .revertFormGroup(id)
      .then((response) => {
        dispatch(receive(response.data.data));
        dispatch(setSubmissionStage(submissionStages.Validating));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, reject, true, false));
        }
      });

    return promise();
  };
}
